module.exports = __webpack_public_path__ + "static/media/blog_5.c6f4db84.jpg";